export default __webpack_public_path__ + "assets/benefits-78b1203.svg";